import { faLayerGroup, faOilWell, faTag } from '@elynx/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AccountTree, CropSquare, CurtainsClosedRounded, ExpandMore, FilterNone, SettingsRemoteRounded, WebStoriesRounded } from "@mui/icons-material";
import { Box, IconButton, Link, Stack, Theme, Tooltip, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { getObjectTypeName } from '../../common/utilities/GetObjectTypeName';
import { IRoute } from '../../routes/routes';
import { INavigationItem } from "../../services/navigation-data-service/Models";
import BreadCrumbGroupMenu from './BreadCrumbGroupMenu';
import BreadCrumbObjectMenu from './BreadCrumbObjectMenu';

export type BreadCrumbObjectItemProps = {
    item: INavigationItem;
    route: IRoute;
    offline: boolean;
    onClick: (item: INavigationItem, route: IRoute, shiftKey: boolean, ctrlKey: boolean) => void;
};

export default function BreadCrumbObjectItem({
    item,
    route,
    offline,
    onClick
}: BreadCrumbObjectItemProps) {
    const anchorRef = useRef<HTMLDivElement | null>(null);
    const [open, setOpen] = useState<boolean>(false);

    function handleOnClick(
        navItem: INavigationItem,
        navRoute: IRoute,
        shiftKey: boolean,
        ctrlKey: boolean
    ) {
        onClick(navItem, navRoute, shiftKey, ctrlKey);
        setOpen(false)
    }

    return (
        <Stack
            direction="column"
            sx={{
                overflow: "hidden"
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden"
                }}
            >
                {`${getObjectTypeName(item.objectTypeID)}`}
            </Typography>
            <Tooltip title={item.title}>
                <Stack
                    direction="row"
                    ref={anchorRef}
                    sx={{
                        alignItems: "center",
                        overflow: "hidden",
                        "& svg": {
                            marginTop: 'auto',
                            marginBottom: 'auto',
                            width: (theme: Theme) => theme.spacing(2),
                            height: (theme: Theme) => theme.spacing(2),
                        }
                    }}
                >
                    <Link
                        sx={{
                            color: "text.secondary",
                            textDecoration: item.isHidden ? 'line-through' : undefined,
                            fontStyle: item.isObjectDisabled || !item.allowClick ? 'italic' : undefined,
                            display: "flex",
                            "&:hover": {
                                textDecoration: item.isHidden ? 'line-through' : undefined,
                                cursor: "pointer"
                            },
                            flexDirection: "row",
                            alignItems: "center",
                            overflow: "hidden"
                        }}
                        onClick={
                            event => handleOnClick(item, route, event.shiftKey, event.ctrlKey)
                        }
                    >
                        {
                            // item.objectTypeID === eLynxObjectTypeEnum.Tag
                            //     ? <FontAwesomeIcon icon={faTag} size='sm' />
                            //     : item.objectTypeID === eLynxObjectTypeEnum.Group
                            //         ? item.isPeerGroup
                            //             ? <AccountTree />
                            //             : <FilterNone />
                            //         : <CropSquare />
                            
                            item.objectTypeID === eLynxObjectTypeEnum.Group
                                ? <FontAwesomeIcon icon={faLayerGroup} size="sm" />
                                : item.objectTypeID === eLynxObjectTypeEnum.Device
                                    ? <SettingsRemoteRounded />
                                    : item.objectTypeID === eLynxObjectTypeEnum.TankBattery
                                        ? <WebStoriesRounded />
                                        : item.objectTypeID === eLynxObjectTypeEnum.Tank
                                            ? <CurtainsClosedRounded />
                                            : item.objectTypeID === eLynxObjectTypeEnum.Well
                                                ? <FontAwesomeIcon icon={faOilWell} size="sm" />
                                                : item.objectTypeID === eLynxObjectTypeEnum.Tag
                                                    ? <FontAwesomeIcon icon={faTag} size="sm" />
                                                    : undefined
                        }

                        <Box
                            sx={{
                                marginTop: 'auto',
                                marginBottom: 'auto',
                                marginLeft: 1,
                                color: "text.primary",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden"
                            }}
                        >
                            {item.title}
                        </Box>
                    </Link>

                    <IconButton
                        size="small"
                        aria-label="related"
                        aria-controls="related-items-menu"
                        aria-haspopup="true"
                        onClick={() => {
                            setOpen(prev => !prev);
                        }}
                        sx={{
                            color: "inherit"
                        }}
                    >
                        <ExpandMore />
                    </IconButton>
                </Stack>
            </Tooltip>
            {item.objectTypeID === eLynxObjectTypeEnum.Group
                ? <BreadCrumbGroupMenu
                    open={open}
                    anchorEl={anchorRef.current}
                    placement="bottom"
                    item={item}
                    route={route}
                    offline={offline}
                    onClick={onClick}
                    onClose={() => setOpen(false)}
                />
                : <BreadCrumbObjectMenu
                    open={open}
                    anchorEl={anchorRef.current}
                    placement="bottom"
                    item={item}
                    route={route}
                    offline={offline}
                    onClick={onClick}
                    onClose={() => setOpen(false)}
                />
            }
        </Stack>
    );
}